export const profile = {
  changePasswordSuccess: "Password changed successfully.",
  changePasswordTitle: "Change your password",
  currentPassword: "Current password",
  currentPasswordPlaceHolder: "Write your current password",
  backToProfile: "Back to profile",
  passwordChanged: "Password changed",
  passwordChangedSuccess: "Your password has been successfully changed",
  goToMyProfile: "Go to my profile",
  changedPasswordSubTitle:
    "Your new password must be different to previously used passwords.",
  greetingTitle: "Welcome {{title}}",
  personalDetailsTitle: "Personal details",
  personalDetails: "Personal Details",
  personalDetailsDescription:
    "Manage your personal information and preferences",
  nameLabel: "Name",
  nationalityLabel: "Nationality",
  changeLogo: "Change Logo",
  logoFormat: "File formats: SVG, PNG, JPEG, GIF",
  invalidFileType: "Please upload only JPEG, PNG, or GIF files",
  fileSizeExceeded: "File size should not exceed 5MB",
  logoUploadedSuccessfully: "Logo uploaded successfully",
  uploadFailed: "Failed to upload logo",
  fullName: "Full Name",
  maritalStatus: "Marital Status",
  countryOfResidence: "Country of Residence",
  city: "City",
  timezone: "Timezone",
  basicInformation: "Basic Information",
  idPassportDocument: "ID/Passport Document",
  idType: "ID Type",
  idNumber: "ID Number",
  issueDate: "Issue Date",
  issuingCountry: "Issuing Country",
  emergencyContact: "Emergency Contact",
  contactName: "Contact Name",
  workingHours: "Working Hours",
  availableDaysTitle: "Available Days",
  contactDetailsTitle: "Contact details",
  availabilityTitle: "Availability",
  from: "From",
  to: "To",
  years: "Years",
  skills: "Skills",
  services: "Services",
  cvTitle: "CV",
  isWillingToTravel: "I'm {{isWillingToTravel}} willing to travel",
  openForSecondment: "Open for secondment",
  relevantProfileTitle: "Relevant profiles",

  "serviceRate-per word": "/word",
  "serviceRate-per hour": "/h",
  "serviceRate-per page": "/page",
  "serviceRate-per slide": "/slide",
  "serviceRate-per minute": "/min",
  "serviceRate-online": "/h-online",
  "serviceRate-on-site": "/h-onsite",
  "serviceRate-online half a day": "/half a day (4h)-online",
  "serviceRate-on-site half a day": "/half a day (4h)-onsite",
  "serviceRate-online full day": "/full day (8h)-online",
  "serviceRate-on site full day": "/full day (8h)-onsite",
  "serviceRate-overtime online": "/overtime hourly-online",
  "serviceRate-overtime on-site": "/overtime hourly-onsite",
  companyDetailsTitle: "Company details",
  companyName: "Company name",
  website: "Website",
  discard: "Discard",
  saveChangesCta: "Save changes",
  gender: "Gender",
  dateOfBirth: "Date of birth",
  dateOfBirthPlaceholder: "DD/MM/YYYY",
  martialStatus: "Marital status",
  placeholderAgency: "Enter {{title}}",
  countryOfBirth: "Country of birth",
  socialSecurityNumber: "Social security number",
  nationalCardNo: "National card number",
  passportNo: "Passport number",
  expiryDate: "Expiry date",

  placeOfIssue: "Place of issue",
  countryOfIssue: "Country of issue",
  qualificationsTitle: "Qualifications",

  university: "University",
  qualifications: "Qualifications",
  major: "Major",
  greetingFormTitle: "Welcome to our community",
  greetingFormSubTitle: "Please complete your profile and start working!",

  permanentAddress: "Permanent address",
  currentResidenceAddress: "Current residence address",
  phoneNumber: "Phone number",
  homeTelephone: "Home telephone",
  country: "Country",
  bankDetails: "Bank details",
  financialInformation: "Financial Details",
  financialInformationSubTitle: "Add your preferred method; including",

  accountName: "Account name",
  bankName: "Bank name",
  accountType: "Account type",
  accountNumber: "Account number",
  swiftCode: "Swift code",
  sortCode: "Sort code",
  iban: "IBAN",
  phonePlaceholder: "00962",

  emergencyContactTitle: "Emergency contact",
  name: "Full name",
  relationship: "Relationship",
  email: "Email",
  saveAndSubmit: "Save and submit",
  addNewContacts: "Add new contacts",
  removeSections: "Remove sections",
  department: "Department",
  position: "Position",
  accountHolderName: "Account holder name",
  accountCurrency: "Account currency",
  bankAddress: "Bank address",
  routingCode: "Routing Code",
  legalDetailsTitle: "Legal details",
  fileDocument: "File documents",
  profileCompletion: "Profile completion",
  completed: "Completed",

  preferredCurrency: "Preferred currency",
  cashExpress: "Cash Express",
  ureed: "Ureed",
  ureedLabel: "Ureed email",
  ureedPlaceholder: "Enter your Ureed email",
  payoneer: "Payoneer",
  payoneerLabel: "Payoneer email",
  payoneerPlaceholder: "Enter your Payoneer email",
  expressFullNameSubTitle: "it should be exactly same as your ID",
  fullName: "Full Name",
  uploadCv: "Upload CVs",
  cvs: "CVs",
  rateValueError: "Value must be a multiple of 0.001",
  paymentTerms: "Payment terms",
  vatRegistrationNumber: "VAT registration number",
  vatExempt: "VAT Exempt",
  vatCertification: "VAT Certification",
  attachUrVat: "Attach your VAT certificate",
  vatCountry: "VAT Country",
  vetted: "tested and onboarded",
  missingSubDomains:
    "Subdomains are missing for the following domains: {{domains}}",
  emptyOrZero: "Value cannot be empty or zero",
  mustBeInteger: "The value cannot have a fractions",
  others: "Others",
  agencyTeam: "Team Members",
  addNewMember: "Add New Member",
  editNewMember: "Edit New Member",
  personalInformation: " Personal Information",
  languagePairs: "Language pairs",
  addAnotherService: "Add Another Service",
  domainsSubdomainTitle: "Domains / Subdomains",
  addAnotherDomain: "Add Another Domain",
  teamMemberCreatedSuccessMsg: "Team member created successfully",
  teamMemberUpdatedSuccessMsg: "Team member updated successfully",
  teamMemberActivityMsg: "Team member {{isActive}} successfully",
  vatExemptApplicable: "VAT Exempt (If applicable)",
  applicable: "(If applicable)",
  beneficiaryName: "Beneficiary Name",
  msgForScanningResume:
    "Scanning your CV to auto-fill your profile . Currently available for English and Arabic CVs!",
  financialDetailsWarning:
    "Please ensure that you provide only the bank details directly associated with the beneficiary. Bank details linked to a first-degree relative or friend are not permitted under our internal procedures.",

  addBankDetails: "Add Bank Details",
  addUreed: "Add Ureed",
  addCurrency: "Add Currency",
  addCashExpress: "Add Cash Express",
  addVat: "Add Vat",
};
